import {useContext} from 'react'

import Context from '@s-ui/react-context'
import SectionBasic from '@adv-mt/mt-section-basic'
import IconInsuranceBikes from '@adv-mt/mt-svg-icons/lib/InsuranceBikes'
import IconInsuranceCars from '@adv-mt/mt-svg-icons/lib/InsuranceCars'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import NewInsuranceCard from './NewInsuranceCard/index.js'

export default function AdvertisingTextlinks() {
  const {track} = useAnalyticsTrack()
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {
    EVENT_CHANNEL_INSURANCE,
    EVENT_ID_DETAIL_CLICKED,
    EVENT_INSURANCE_CLICKED,
    INSURANCE_DETAIL_CARD_LOGOS_URL,
    URL_INSURANCE_BUTTON
  } = config.get('advertising')
  const APP_NAME = config.get('APP_NAME')
  const APP_NAME_COCHES = config.get('APP_NAME_COCHES')

  const isCoches = APP_NAME === APP_NAME_COCHES

  const handleClickWithSegmentTracking = () => {
    track({
      event: EVENT_INSURANCE_CLICKED,
      data: {
        channel: EVENT_CHANNEL_INSURANCE,
        event_id: EVENT_ID_DETAIL_CLICKED
      }
    })
  }

  return (
    <SectionBasic title={i18n.t('ADDITIONAL_SERVICES')}>
      <NewInsuranceCard
        boldText={i18n.t('INSURANCE_BOLD_TEXT')}
        buttonTitle={i18n.t('INSURANCE_BUTTON_TEXT_NEW')}
        clickUrl={URL_INSURANCE_BUTTON}
        handleClick={handleClickWithSegmentTracking}
        icon={isCoches ? <IconInsuranceCars /> : <IconInsuranceBikes />}
        logosUrl={INSURANCE_DETAIL_CARD_LOGOS_URL}
        regularText={i18n.t('INSURANCE_REGULAR_TEXT')}
        logoAltText={i18n.t('INSURANCE_LOGOS_ALT_TEXT')}
      />
    </SectionBasic>
  )
}

AdvertisingTextlinks.displayName = 'AdvertisingTextlinks'
AdvertisingTextlinks.propTypes = {}
